import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";

import useToggle from "../../../components/useToggle";
import Modal from "../../../components/Modal";

import "./header.styles.css";
import TextInput from "../../../components/TextInput";
import Button from "../../../components/Button";

const Header = ({ onToggleModal }) => {
  const [visible, setVisible] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [settingsModal, setSettingsModal] = useState(false);

  const dropdownheader = useRef();
  const actionsdropdown = useRef();

  useToggle(dropdownheader, dropdown, setDropdown);
  useToggle(actionsdropdown, visible, setVisible);

  const toggleModalModal = () => {
    setSettingsModal(!settingsModal);
    setDropdown(false);
  };

  return (
    <header className="header__navigation d-flex align-items-center justify-content-between">
      <div className="">
        <div
          className="header__navigation--user"
          onClick={() => setDropdown(!dropdown)}
          ref={dropdownheader}
        >
          <span className="name__logo">KM</span>
          <span className="name--title">Knox Mabel</span>
          <span className="dropdown--icon">
            <svg
              width="14"
              height="8"
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.292893 0.292893C0.683418 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
                fill="#0D0D0D"
              />
            </svg>
          </span>

          <div
            className={
              dropdown
                ? "header__navigation--dropdown is--visible"
                : "header__navigation--dropdown"
            }
          >
            <div className="d-flex align-items-center padder mt--8">
              <span className="name__logo rounded">KM</span>
              <span className="name--title">Knox@klen.co</span>
            </div>
            <div className="padder mtb--8" onClick={toggleModalModal}>
              <h6>Settings</h6>
            </div>
            <div className="padder logout">
              <h6>Log out</h6>
            </div>
          </div>
        </div>
      </div>
      <div className="header__navigation--actions">
        <span className="">
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 13.1227H1L3.15126 9.37342L3.25635 6.93132C3.3557 4.62279 4.82369 2.59655 6.98637 1.78288L7.10902 1.73674C8.36927 1.26259 9.76079 1.27399 11.0131 1.76871C13.0844 2.58697 14.4454 4.58789 14.4454 6.81498V9.37342L17 13.1227Z"
              stroke="#2C2B35"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.43652 12.9976V12.9976C5.43652 14.637 6.22923 16.2663 7.7901 16.7679C8.2673 16.9212 8.75833 17.0196 9.20123 16.9968C9.5621 16.9782 9.95415 16.8758 10.3366 16.7347C11.7337 16.219 12.4281 14.7367 12.4281 13.2475V13.2475"
              stroke="#2C2B35"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </span>
        <span className="help--section">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5229 0 20 4.47715 20 10C20 15.5228 15.5229 20 10 20C4.47715 20 0 15.5228 0 10Z"
              fill="#2C2B35"
            />
            <path
              d="M10 12C9.44772 12 9 11.5523 9 11V10C9 9.44771 9.44772 9 10 9C10.5523 9 11 9.44771 11 10V11C11 11.5523 10.5523 12 10 12Z"
              fill="#2C2B35"
            />
            <path
              d="M8.5 14.5C8.5 13.6716 9.17158 13 10 13C10.8284 13 11.5 13.6716 11.5 14.5C11.5 15.3284 10.8284 16 10 16C9.17158 16 8.5 15.3284 8.5 14.5Z"
              fill="#2C2B35"
            />
            <path
              d="M10.3899 5.81137C9.43291 5.7658 8.6304 6.3004 8.4864 7.1644C8.3956 7.70917 7.88037 8.07719 7.3356 7.9864C6.79083 7.8956 6.42281 7.38037 6.51361 6.8356C6.86961 4.69961 8.8171 3.73421 10.4851 3.81363C11.3395 3.85432 12.2176 4.16099 12.8937 4.79278C13.5866 5.44027 14 6.36777 14 7.5C14 8.79131 13.4919 9.74892 12.6172 10.3321C11.8141 10.8675 10.8295 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44771 9.44772 9 10 9C10.6705 9 11.186 8.88252 11.5078 8.66795C11.7581 8.50109 12 8.2087 12 7.5C12 6.88224 11.7884 6.49723 11.5282 6.2541C11.2512 5.99526 10.848 5.83318 10.3899 5.81137Z"
              fill="#2C2B35"
            />
          </svg>
          <Link to="/help">Help</Link>
        </span>
        <div className="course__container" ref={actionsdropdown}>
          <button onClick={() => setVisible(!visible)}>
            Create new{" "}
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0002 2.66683C5.95007 2.66683 2.66683 5.95008 2.66683 10.0002C2.66683 14.0503 5.95007 17.3335 10.0002 17.3335C14.0503 17.3335 17.3335 14.0503 17.3335 10.0002C17.3335 5.95008 14.0503 2.66683 10.0002 2.66683ZM0.833496 10.0002C0.833496 4.93755 4.93755 0.833496 10.0002 0.833496C15.0628 0.833496 19.1668 4.93755 19.1668 10.0002C19.1668 15.0628 15.0628 19.1668 10.0002 19.1668C4.93755 19.1668 0.833496 15.0628 0.833496 10.0002ZM10.0002 5.41683C10.5064 5.41683 10.9168 5.82724 10.9168 6.3335V9.0835H13.6668C14.1731 9.0835 14.5835 9.4939 14.5835 10.0002C14.5835 10.5064 14.1731 10.9168 13.6668 10.9168H10.9168V13.6668C10.9168 14.1731 10.5064 14.5835 10.0002 14.5835C9.4939 14.5835 9.0835 14.1731 9.0835 13.6668V10.9168H6.3335C5.82723 10.9168 5.41683 10.5064 5.41683 10.0002C5.41683 9.4939 5.82723 9.0835 6.3335 9.0835H9.0835V6.3335C9.0835 5.82724 9.4939 5.41683 10.0002 5.41683Z"
                  fill="white"
                />
              </svg>
            </span>
          </button>
          <div
            className={
              visible
                ? "course__creation--selection is--visible"
                : "course__creation--selection"
            }
          >
            <div
              className="course__creation-option"
              onClick={() => onToggleModal("Create interactive workshop")}
            >
              <h6>Interactive workshop</h6>
            </div>
            <div
              className="course__creation-option"
              onClick={() => onToggleModal("Create interactive course")}
            >
              <h6>Interactive course</h6>
            </div>
          </div>
        </div>
      </div>
      <Modal
        visible={settingsModal}
        title="Settings"
        btnTitle="Delete my account permanently"
        btnType="delete"
        onClose={() => setSettingsModal(false)}
        footerText="Please note deleting your account is permanent and cannot be reversed"
      >
        <div className="settings__modal d-flex ">
          <div className="left__section d-flex flex-column">
            <span>KM</span>
            <button>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.91075 3.57757C7.06703 3.42129 7.27899 3.3335 7.5 3.3335H12.5C12.721 3.3335 12.933 3.42129 13.0893 3.57757L14.5118 5.00016H16.6667C17.5871 5.00016 18.3333 5.74636 18.3333 6.66683V15.0002C18.3333 15.9206 17.5871 16.6668 16.6667 16.6668H3.33334C2.41286 16.6668 1.66667 15.9206 1.66667 15.0002V6.66683C1.66667 5.74635 2.41286 5.00016 3.33334 5.00016H5.48816L6.91075 3.57757ZM7.84518 5.00016L6.42259 6.42275C6.26631 6.57903 6.05435 6.66683 5.83334 6.66683L3.33334 6.66683V15.0002H16.6667V6.66683H14.1667C13.9457 6.66683 13.7337 6.57903 13.5774 6.42275L12.1548 5.00016H7.84518ZM10 8.75016C9.07953 8.75016 8.33334 9.49636 8.33334 10.4168C8.33334 11.3373 9.07953 12.0835 10 12.0835C10.9205 12.0835 11.6667 11.3373 11.6667 10.4168C11.6667 9.49636 10.9205 8.75016 10 8.75016ZM6.66667 10.4168C6.66667 8.57588 8.15906 7.0835 10 7.0835C11.841 7.0835 13.3333 8.57588 13.3333 10.4168C13.3333 12.2578 11.841 13.7502 10 13.7502C8.15906 13.7502 6.66667 12.2578 6.66667 10.4168Z"
                  fill="#39006B"
                />
              </svg>
              Upload new photo
            </button>
          </div>
          <div className="right__section">
            <div className="w--full mt--16">
              <TextInput
                label="First name"
                placeholder="Knox"
                type="text"
                name="first_name"
              />
            </div>
            <div className="w--full mt--16">
              <TextInput
                label="Last name"
                placeholder="Mabel"
                type="text"
                name="last_name"
              />
            </div>
            <div className="mt--16">
              <Button title="Save" size="large" type="primary" />
            </div>
            <div className="w--full mt--24 contact--email">
              <h6>Contact email address</h6>
              <p>Knox@klen.co</p>
            </div>
          </div>
        </div>
      </Modal>
    </header>
  );
};

export default Header;
